//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false, _: false */
import universalImageActionsFanreelTemplate from '@legacy-components/common/universal-image-actions/universal-image-actions-fanreel.html';

(function() {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsFanreel', [
    'PermissionsService',
    'UniversalImageActionsService',
    function(
            PermissionsService,
            UniversalImageActionsService,
        ) {
      return {
        restrict: 'E',
        scope: {},
        template: universalImageActionsFanreelTemplate,
        link(scope) {
          scope.model = {
            selectedReel: null,
            outstandingAsyncAction: null,
            isCaasModerationReel: false,
          };

          const canViewModerationReels = PermissionsService.hasPermissionForTask('moderation_services:view_moderation_reels');

          scope.model.outstandingAsyncAction = 'getReels';
          UniversalImageActionsService.getCachedReelsAsync().then((reels) => {
            scope.model.reels = reels;
            scope.model.selectedReel = UniversalImageActionsService.getSelectedReel() || reels[0];
            scope.model.isCaasModerationReel = _(reels).findWhere({ id: scope.model.selectedReel.id }).isCaasModerationReel;

                        // Only display canvases and reels separately if the chosen client has both
            scope.model.showCanvasesSeparately = _(reels).some((reel) => {
              return reel.isCanvas;
            }) && _(reels).some((reel) => {
              return !reel.isCanvas;
            });

            return UniversalImageActionsService.refreshReelMetadataAsync(scope.model.selectedReel.id);
          }).finally(() => {
            scope.model.outstandingAsyncAction = null;
          });

          scope.model.changeSelectedReel = function(newReelId) {
            const newReel = _(scope.model.reels).find((reel) => {
              return reel.id === newReelId;
            });

            if (newReel && !angular.equals(newReel, scope.model.selectedReel)) {
              scope.model.selectedReel = newReel;
            }
          };

          scope.model.filterReelsWithProperties = function(propertyFilters) {
            return function(reel) {
                            // If this isn't a CaaS mod reel and !canViewModerationReels, only show non-CaaS-mod reels.
                            // If this isn't a CaaS mod reel and canViewModerationReels, show both non-CaaS-mod and CaaS mod reels.
                            // If this is a CaaS mod reel, only show reels that are also CaaS mod reels.
                            // Basically, only show ALL (including CaaS mod reels) if we aren't in a CaaS mod reel and canViewModerationReels. This allows
                            // Curalate Moderation Services to send content to any reel from around the dashboard, but within a CaaS mod reel they can only
                            // approve to CaaS mod reels.

              if (!(!scope.model.isCaasModerationReel && canViewModerationReels)) {
                _(propertyFilters).extend({ isCaasModerationReel: scope.model.isCaasModerationReel });
              }

              return _([reel]).where(propertyFilters).length > 0;
            };
          };

          scope.$watch('model.selectedReel', (newVal) => {
            UniversalImageActionsService.setSelectedReel(newVal);
          });
        },
      };
    },
  ]);
})();
